"use client";

import { cn } from "@jesus-central-church/shared";
import { EventCardWide } from "./event-card-wide";
import type { EventUI } from "./types";

export interface EventsListProperties {
  events: EventUI[];
  className?: string;
}

export function EventsList({ events, className }: EventsListProperties) {
  return (
    <div className={cn("space-y-4", className)}>
      {events.map((event) => (
        <EventCardWide
          key={event.id}
          event={event}
          variant={event.featured ? "featured" : "default"}
        />
      ))}
    </div>
  );
}
